import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetAuthData } from './auth.actions';
import { AuthStateModel } from './auth.model';
import { WebSocketService } from '../../../core/websocket/websocket.service';



@State<AuthStateModel>({
  name: 'authState',
  defaults: {
    authenticatedUser: {
      sub: '',
      firstName: '',
      surname: '',
      email: '',
      role: ''
    }
  }
})
@Injectable()
export class AuthState {
  private webSocketService = inject(WebSocketService);
  @Selector()
  static getAuthData(state: AuthStateModel): AuthStateModel {
    return AuthState.getInstanceState(state);
  }

  private static setInstanceState(state: AuthStateModel): AuthStateModel {
    return { ...state };
  }

  private static getInstanceState(state: AuthStateModel): AuthStateModel {
    return { ...state };
  }

  @Action(SetAuthData)
  setAuthData(
    { setState }: StateContext<AuthStateModel>,
    { payload }: SetAuthData
  ) {
    setState(AuthState.setInstanceState(payload));
  }

}
